import { AccountMachineState } from './account.machine';

export const selectSubmitButtonState = (state: AccountMachineState) =>
	state.context.submitButtonState;
